// extracted by mini-css-extract-plugin
export var displayNone = "_qr-6";
export var imgContainer = "_qr-2";
export var overflowHidden = "_qr-3";
export var productInfoCardButtonContainer = "_qr-5";
export var productTitleText = "_qr-4";
export var rightArrow = "_qr-1";
export var rightArrowContainer = "_qr-0";